module.exports = __webpack_public_path__ + "img/c2.c5755e26.png";